import { Dialog } from '@headlessui/react'
import { ExclamationTriangleIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline'

const variants = {
  warning: {
    icon: ExclamationTriangleIcon,
    iconClasses: 'text-yellow-500',
    bgClasses: 'bg-yellow-50',
    titleDefault: 'Are you sure?',
  },
  info: {
    icon: QuestionMarkCircleIcon,
    iconClasses: 'text-blue-500',
    bgClasses: 'bg-blue-50',
    titleDefault: 'Please confirm',
  },
}

export default function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  loading = false,
  type = 'warning',
}) {
  const variant = variants[type] || variants.warning
  const Icon = variant.icon

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-md rounded-2xl bg-white shadow-xl">
          <div className={`flex items-start space-x-4 rounded-t-2xl px-6 py-5 ${variant.bgClasses}`}>
            <div className="flex-shrink-0">
              <Icon className={`h-8 w-8 ${variant.iconClasses}`} />
            </div>
            <div>
              <Dialog.Title className="text-lg font-semibold text-gray-900">
                {title || variant.titleDefault}
              </Dialog.Title>
              {message && (
                <Dialog.Description className="mt-2 text-sm text-gray-600">
                  {message}
                </Dialog.Description>
              )}
            </div>
          </div>
          <div className="px-6 py-4 bg-gray-50 rounded-b-2xl flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              disabled={loading}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={loading}
              className="inline-flex justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
            >
              {loading ? 'Processing...' : confirmLabel}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}
